import { BlogService } from '@core/services/blog/blog.service';
import { IBlogType } from '@introspection/index';
import { Component, DefineDependencies } from '@rhtml/component';
import { Container } from '@rxdi/core';
import { css, html, LitElement } from '@rxdi/lit-html';
import { Router } from '@rxdi/router';
import { PostCardComponent, postUrl } from '@shared/components/post-card/post-card.component';
import { ArrowIcon, StudioStyles } from '@shared/styles/studio.styles';
import { map } from 'rxjs/operators';

interface JournalState {
  posts: IBlogType[];
}

const LATEST = 3;

const styles = css`
  .head {
    display: flex;
    justify-content: space-between;
    align-items: end;
    gap: 24px;
    flex-wrap: wrap;
    margin-bottom: clamp(36px, 5vw, 64px);
  }

  .posts {
    display: grid;
    gap: 16px;
  }

  @media (min-width: 900px) {
    .posts {
      grid-template-columns: repeat(3, 1fr);
    }
  }
`;

const frame = (content: unknown, onAll?: () => void) => html`
  <section class="section" id="journal">
    <div class="wrap">
      <div class="head">
        <div>
          <span class="kicker"><span class="index">06</span> Journal</span>
          <h2 class="h2">Notes from <em>the workshop</em>.</h2>
        </div>
        <a class="btn btn-ghost" href="/blog" @click=${(e: Event) => (e.preventDefault(), onAll?.())}>
          All articles ${ArrowIcon}
        </a>
      </div>
      ${content}
    </div>
  </section>
`;

/** Home: the latest articles from the blog (data from the API, Style A). */
@Component({
  Settings: {
    selector: 'rs-journal',
    styles: [StudioStyles, styles],
    components: [PostCardComponent],
  },
  Providers: DefineDependencies(BlogService)(Container),
  Loading: () =>
    frame(html`<div class="posts">${[0, 1, 2].map(() => html`<div class="card skeleton skeleton-card"></div>`)}</div>`),
  Error: () => html``,
  State: function (this: JournalComponent, [blog]) {
    return blog.listPosts().pipe(
      map(
        (posts): JournalState => ({
          posts: (posts ?? [])
            .filter((p) => !p.draft)
            .sort((a, b) => Number(b.createdAt) - Number(a.createdAt))
            .slice(0, LATEST),
        })
      )
    );
  },
  Render: () =>
    function (this: JournalComponent, state: JournalState) {
      if (!state.posts.length) {
        return html``;
      }
      return frame(
        html`<div class="posts">
          ${state.posts.map(
            (post) => html`<rs-post-card .post=${post} @open=${() => this.go(postUrl(post))}></rs-post-card>`
          )}
        </div>`,
        () => this.go('/blog')
      );
    },
})
export class JournalComponent extends LitElement {
  @Router() router: Router;

  go(path: string) {
    this.router.go(path);
    window.scrollTo({ top: 0 });
  }
}
